<template>
    <div class="footerBox">
        <div class="con visible-md-block visible-lg-block">
            <ul class="cl">
                <li class="fl col">
                    <div class="title">{{$t('lang.homePage.rmal')}}</div>
                    <div class="desc"><router-link to="/product">Invasion</router-link></div>
                    <!--<div class="desc"><router-link to="/product/brutalAge">Brutal Age</router-link></div>-->
                    <div class="desc"><router-link to="/product/vampireEmpire">Vampire Empire</router-link></div>
                    <!--<div class="desc"><router-link to="/product/totalDestruction">Total Destruction</router-link></div>-->
                </li>
                <li class="fl col">
                    <div class="title">{{$t('lang.homePage.gs')}}</div>
                    <div class="desc" ><router-link to="/home">{{$t('lang.homePage.gsfzlc')}}</router-link>></div>
                    <div class="desc" ><router-link to="/home">{{$t('lang.homePage.tdsl')}}</router-link>></div>
                </li>
                <li class="fl col">
                    <div class="title">{{$t('lang.homePage.fl')}}</div>
                    <div class="desc"><router-link to="/cookie">{{$t('lang.homePage.cookie')}}</router-link></div>
                    <div class="desc"><router-link to="/sytk">{{$t('lang.homePage.sytk')}}</router-link></div>
                </li>
            </ul>
            <div style="text-align: center;margin-top: 60px"><img src="../../assets/images/logo.png" alt="" height="40px"></div>
        </div>
        <div class="mobile visible-xs-block visible-sm-block">
            <ul>
                <li class="col">
                    <div class="title">{{$t('lang.homePage.rmal')}}</div>
                    <div class="desc"><router-link to="/product">Invasion</router-link></div>
                    <!--<div class="desc"><router-link to="/product/brutalAge">Brutal Age</router-link></div>-->
                    <div class="desc"><router-link to="/product/vampireEmpire">Vampire Empire</router-link></div>
                    <!--<div class="desc"><router-link to="/product/totalDestruction">Total Destruction</router-link></div>-->
                </li>
                <li class="col">
                    <div class="title">{{$t('lang.homePage.gs')}}</div>
                    <div class="desc"><a href="">{{$t('lang.homePage.gsfzlc')}}</a></div>
                    <div class="desc"><a href="">{{$t('lang.homePage.tdsl')}}</a></div>
                </li>
                <li class="col">
                    <div class="title">{{$t('lang.homePage.fl')}}</div>
                    <div class="desc"><router-link to="/cookie">{{$t('lang.homePage.cookie')}}</router-link></div>
                    <div class="desc"><router-link to="/sytk">{{$t('lang.homePage.sytk')}}</router-link></div>
                </li>
            </ul>
            <div class="footerLogoBox" style="text-align: center;margin-top: 20px"><img src="../../assets/images/logo.png" alt="" height="40px"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FooterBox"
    }
</script>

<style>
    .footerBox{
        background: #000;
        background-image: url("../../assets/images/footerImg.png");
        background-size: auto 100%;
        background-repeat: no-repeat;
        background-position: center;
    }

    .footerBox .con{
        width: 80%;
        margin: 0 auto;
        padding-top: 60px;
        height: 340px;
    }
    .footerBox .con ul li{
        width: 33.3%;
    }
    .footerBox .con .col{
        padding: 0 10%;
    }
    .footerBox .title{
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 25px;
    }
    .footerBox .desc{
        font-size: 12px;
        line-height: 20px;
        color: #807f7f;
        margin-bottom: 10px;
    }
    .footerBox .desc a{
        color: #807f7f;
        font-weight: bold;
    }

    .footerBox .mobile{
        padding: 50px 0  ;
    }
    .footerBox .mobile .col{
        text-align: center;
        margin-bottom: 30px;
    }
    @media (max-width: 992px){
        .footerBox{
            background-image: url('');
            background-size: 100% auto;
        }
        .footerLogoBox{
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/views/FooterBox.vue